import AppProjectPage from "../app"

const debug = false
// const debug = "page_toggleShowControls"

export default function page_toggleShowControls(value: boolean) {
    const app: AppProjectPage = gd.getMainApp() as AppProjectPage

    const localSettings = app.editorLocalSettings
    const newValue       = !_.isNil(value) ? value : !localSettings.showControls
    const isValueChanged = localSettings.showControls !== newValue

    localSettings.showControls = newValue
    localSettings.save()

    debug && console.log(debug, 'isValueChanged', value, newValue, isValueChanged)

    if (isValueChanged) {
        app.render()
    }
}